(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-body"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ab-toc]').forEach(function (toc) {
    if (toc._abReady) return;
    toc._abReady = true;

    var root = toc.closest('.page-width');
    var main = root && root.querySelector('[data-ab-main]');
    if (!main) return;

    var headings = Array.prototype.slice.call(main.querySelectorAll('h2'));
    if (headings.length < 2) return;

    var nav = toc.querySelector('[data-ab-toc-nav]');
    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'ab-toc-' + i;
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      nav.appendChild(a);
    });

    toc.hidden = false;

    var links = Array.prototype.slice.call(nav.querySelectorAll('a'));
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var link = nav.querySelector('a[href="#' + entry.target.id + '"]');
        if (!link) return;
        if (entry.isIntersecting) {
          links.forEach(function (l) { l.classList.remove('is-active'); });
          link.classList.add('is-active');
        }
      });
    }, { rootMargin: '-100px 0px -70% 0px' });

    headings.forEach(function (h) { observer.observe(h); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-poradna-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-bpg-grid]').forEach(function (grid) {
    var root = grid.closest('.bpg-wrap');
    if (!root || root._bpgReady) return;
    root._bpgReady = true;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-bpg-card]'));
    var typChips = Array.prototype.slice.call(root.querySelectorAll('[data-bpg-typ-chip]'));
    var emptyEl = root.querySelector('[data-bpg-empty]');
    var moreWrap = root.querySelector('[data-bpg-more]');
    var moreBtn = root.querySelector('[data-bpg-loadmore]');
    var BATCH = parseInt(root.getAttribute('data-bpg-batch'), 10) || 9;

    var activeTyp = '';
    var visible = BATCH;

    function matches(card) {
      return activeTyp === '' || card.getAttribute('data-typ') === activeTyp;
    }

    function render() {
      var matched = cards.filter(matches);
      matched.forEach(function (card, i) { card.hidden = i >= visible; });
      cards.filter(function (c) { return !matches(c); }).forEach(function (c) { c.hidden = true; });
      if (emptyEl) emptyEl.hidden = matched.length !== 0;
      if (moreWrap) moreWrap.hidden = matched.length <= visible;
    }

    typChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeTyp = chip.getAttribute('data-typ') || '';
        visible = BATCH;
        typChips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        render();
      });
    });
    if (moreBtn) moreBtn.addEventListener('click', function () { visible += BATCH; render(); });

    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-study-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-csg-track]').forEach(function (track) {
    if (track._csgReady) return;
    track._csgReady = true;

    var root = track.closest('.page-width');
    if (!root) return;

    var dataEl = root.querySelector('[data-csg-data]');
    var photos = [];
    try { photos = JSON.parse(dataEl.textContent); } catch (e) { photos = []; }
    if (!photos.length) return;

    var prevArrow = root.querySelector('[data-csg-track-prev]');
    var nextArrow = root.querySelector('[data-csg-track-next]');
    function scrollPage(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.92, behavior: 'smooth' });
    }
    if (prevArrow) prevArrow.addEventListener('click', function () { scrollPage(-1); });
    if (nextArrow) nextArrow.addEventListener('click', function () { scrollPage(1); });

    var modal = root.querySelector('[data-csg-modal]');
    document.body.appendChild(modal);
    var img = modal.querySelector('[data-csg-modal-img]');
    var counter = modal.querySelector('[data-csg-counter]');
    var current = 0;

    function render() {
      img.src = photos[current].src;
      img.alt = photos[current].alt;
      if (counter) counter.textContent = (current + 1) + ' / ' + photos.length;
    }
    function open(i) {
      current = (i + photos.length) % photos.length;
      render();
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }
    function step(delta) {
      current = (current + delta + photos.length) % photos.length;
      render();
    }

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-csg-thumb]'));
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(parseInt(btn.getAttribute('data-index'), 10) || 0);
      });
    });

    var closeBtn = modal.querySelector('[data-csg-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });

    var prevBtn = modal.querySelector('[data-csg-prev]');
    var nextBtn = modal.querySelector('[data-csg-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });

    var touchStartX = null;
    modal.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    modal.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      touchStartX = null;
    }, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-study-related"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-csr-card]').forEach(function (card) {
    if (card._csrReady) return;
    card._csrReady = true;
    card.addEventListener('click', function () {
      if (!window.dataLayer) return;
      window.dataLayer.push({
        event: 'select_item',
        item_list_name: 'Ďalšie referencie',
        items: [{ item_name: card.getAttribute('aria-label') }]
      });
    });
  });

  // Primary CTA on the case-study detail template — delegated so it also catches the closing
  // CTA band and the theme-wide sticky mobile CTA bar, both of which link to
  // /pages/konfigurator, without touching those shared files.
  //
  // This is a CTA CLICK, not a conversion. It used to push `generate_lead`, which double-counted:
  // the click fired one and actually submitting the configurator fired the real one from
  // configurator-v3.js → track(). The agreed conversion is a form delivered to Raynet, so
  // `generate_lead` is reserved for that and this is its own micro-conversion.
  if (!window._csConfiguratorCtaBound) {
    window._csConfiguratorCtaBound = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href*="konfigurator"]');
      if (!link || !window.dataLayer) return;
      window.dataLayer.push({ event: 'configurator_cta_click', link_url: link.href });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novinky-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ng-grid]').forEach(function (grid) {
    var root = grid.closest('.ng-wrap');
    if (!root || root._ngReady) return;
    root._ngReady = true;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ng-card]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ng-chip]'));
    var emptyEl = root.querySelector('[data-ng-empty]');
    var moreWrap = root.querySelector('[data-ng-more]');
    var moreBtn = root.querySelector('[data-ng-loadmore]');
    var BATCH = parseInt(root.getAttribute('data-ng-batch'), 10) || 9;

    var active = '';
    var visible = BATCH;

    function matches(card) {
      return active === '' || card.getAttribute('data-kategoria') === active;
    }

    function render() {
      var matched = cards.filter(matches);
      matched.forEach(function (card, i) { card.hidden = i >= visible; });
      cards.filter(function (c) { return !matches(c); }).forEach(function (c) { c.hidden = true; });
      if (emptyEl) emptyEl.hidden = matched.length !== 0;
      if (moreWrap) moreWrap.hidden = matched.length <= visible;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        active = chip.getAttribute('data-kategoria') || '';
        visible = BATCH;
        chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        render();
      });
    });
    if (moreBtn) moreBtn.addEventListener('click', function () { visible += BATCH; render(); });

    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poradna-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pg-wrap').forEach(function (root) {
    if (root._pgReady) return;
    root._pgReady = true;

    var jobs = Array.prototype.slice.call(root.querySelectorAll('[data-pg-job]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-pg-chip]'));
    var emptyEl = root.querySelector('[data-pg-empty]');

    function render() {
      var active = root.querySelector('.pg-chip.is-active').getAttribute('data-kategoria') || '';
      var anyVisible = false;

      jobs.forEach(function (job) {
        var cards = Array.prototype.slice.call(job.querySelectorAll('[data-pg-card]'));
        var jobHasVisible = false;
        cards.forEach(function (card) {
          var match = active === '' || card.getAttribute('data-kategoria') === active;
          card.hidden = !match;
          if (match) jobHasVisible = true;
        });
        job.hidden = !jobHasVisible;
        if (jobHasVisible) anyVisible = true;
      });

      if (emptyEl) emptyEl.hidden = anyVisible;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        render();
      });
    });

    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["referencie-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-rg-grid]').forEach(function (grid) {
    var root = grid.closest('.rg-wrap');
    if (!root || root._rgReady) return;
    root._rgReady = true;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-rg-card]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-rg-chip]'));
    var resetBtn = root.querySelector('[data-rg-reset]');
    var countEl = root.querySelector('[data-rg-count]');
    var emptyEl = root.querySelector('[data-rg-empty]');
    var moreWrap = root.querySelector('[data-rg-more]');
    var moreBtn = root.querySelector('[data-rg-loadmore]');
    var BATCH = parseInt(root.getAttribute('data-rg-batch'), 10) || 12;

    var active = '';
    var visible = BATCH;

    function matches(card) {
      if (active === '') return true;
      var kats = (card.getAttribute('data-kategoria') || '').split(' ');
      return kats.indexOf(active) !== -1;
    }

    function pushGA(event, extra) {
      if (!window.dataLayer) return;
      window.dataLayer.push(Object.assign({ event: event }, extra || {}));
    }

    function render(fireGA) {
      var matched = cards.filter(matches);
      matched.forEach(function (card, i) {
        card.hidden = i >= visible;
      });
      cards.filter(function (c) { return !matches(c); }).forEach(function (c) { c.hidden = true; });

      if (countEl) {
        countEl.textContent = matched.length + ' ' + countEl.getAttribute('data-rg-suffix');
      }
      if (emptyEl) emptyEl.hidden = matched.length !== 0;
      if (moreWrap) moreWrap.hidden = matched.length <= visible;

      if (fireGA) {
        pushGA('view_item_list', {
          item_list_name: 'Referencie' + (active ? ' — ' + active : ''),
          items: matched.slice(0, visible).map(function (c) {
            return { item_name: c.getAttribute('aria-label'), item_category: (c.getAttribute('data-kategoria') || '').split(' ')[0] };
          })
        });
      }
    }

    function setActive(slug, updateUrl) {
      active = slug || '';
      visible = BATCH;
      chips.forEach(function (chip) {
        chip.classList.toggle('is-active', (chip.getAttribute('data-kategoria') || '') === active);
      });
      if (resetBtn) resetBtn.hidden = active === '';

      if (updateUrl) {
        var url = new URL(window.location.href);
        if (active) url.searchParams.set('kategoria', active);
        else url.searchParams.delete('kategoria');
        window.history.replaceState({}, '', url);
      }
      render(true);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var slug = chip.getAttribute('data-kategoria') || '';
        setActive(active === slug ? '' : slug, true);
      });
    });
    if (resetBtn) resetBtn.addEventListener('click', function () { setActive('', true); });
    if (moreBtn) moreBtn.addEventListener('click', function () {
      visible += BATCH;
      render(false);
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        pushGA('select_item', {
          item_list_name: 'Referencie',
          items: [{ item_name: card.getAttribute('aria-label'), item_category: (card.getAttribute('data-kategoria') || '').split(' ')[0] }]
        });
      });
    });

    var initial = new URLSearchParams(window.location.search).get('kategoria') || '';
    setActive(initial, false);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
